<template>
  <div class="beneficios">
    <div class="row">
      <div class="col-xs-12">
        <h2 class="page-header">Pagamentos de Benefícios</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <data-table
          ref="vuetable"
          :show-empty="true"
          title="Lista de Pagamentos"
          api-url="assistencia/pagamentos/listar"
          report-title="Pagamentos"
          :fields="fields"
          :initial-page="pagina"
          :pageCollection="'assistenciaPagamentos'"
          :appendParams="filtros"
        >
          <template slot="filters">
            <div class="col-xs-12">
              <h3 class="custom-font">Filtros</h3>
            </div>
            <div class="col-xs-12 form-group">
              <label class="custom-font">Nome</label>
              <input
                name="filter_nome"
                v-model="nome"
                type="text"
                class="form-control"
                placeholder="Digite um nome..."
              />
            </div>
            <div class="col-xs-6 col-sm-4 form-group">
              <label class="custom-font">Ano</label>
              <the-mask :mask="'####'" v-model="ano" class="form-control" />
            </div>
            <div class="col-xs-6 col-sm-4 form-group">
              <label class="custom-font">Mês</label>
              <div class="custom-select">
                <select
                  v-model="mes"
                  class="form-control select-selected"
                  @change="consultar"
                >
                  <option :key="0" :value="''">Todos</option>
                  <option
                    v-for="(mes, index) in meses"
                    :key="`${index}-${mes}`"
                    :value="index + 1"
                    >{{ mes }}</option
                  >
                </select>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 form-group">
              <label class="control-label custom-font">Benefício</label>
              <div class="custom-select">
                <select
                  ref="beneficio"
                  class="form-control select-selected"
                  name="beneficio"
                  @change="consultar"
                  v-model="beneficio"
                  v-validate="'required'"
                >
                  <option :key="0" :value="''">Todos</option>
                  <option
                    v-for="item in beneficios"
                    :key="item.codigo"
                    :value="item.codigo"
                  >
                    {{ item.sigla }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-xs-12">
              <button class="btn btn-default" @click="consultar()">
                <font-awesome-icon :icon="'search'" />
                Consultar
              </button>
              <button class="btn btn-default" @click="limpar()">
                <font-awesome-icon :icon="'eraser'" />
                Limpar dados
              </button>
            </div>
          </template>
          <template slot="icon" slot-scope="props">
            {{ retornarPeriodo(props.rowData) }}
          </template>
          <template slot="actions" class="form-group">
            <router-link
              class="btn btn-default"
              :to="'/admin/assistencia/load'"
            >
              <font-awesome-icon :icon="'plus'" /> Adicionar
            </router-link>
          </template>
          <template slot="rowrender" slot-scope="props">
            <div class="">
              <button
                title="Editar"
                type="button"
                class="btn btn-primary"
                @click="
                  $router.push({
                    name: 'pagamentos_edit',
                    params: { item: props.rowData }
                  })
                "
              >
                <font-awesome-icon :icon="'edit'" />
              </button>
              <button
                title="Excluir"
                class="btn btn-danger"
                @click="excluir(props.rowData)"
              >
                <font-awesome-icon :icon="'trash-alt'" />
              </button>
            </div>
          </template>
        </data-table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}
</style>

<script>
import DataTable from '@/components/common/DataTable'
import { request } from '@/request'
import { TheMask } from 'vue-the-mask'
import { mesesExt, formatarMoeda } from '@/utils/strings'

export default {
  inject: ['showConfirm'],
  components: {
    DataTable,
    TheMask
  },
  data() {
    return {
      meses: mesesExt,
      beneficios: [],
      fields: [
        {
          name: 'data',
          title: 'Data',
          callback(value) {
            return new Date(`${value}`).toLocaleDateString()
          }
        },
        {
          name: 'beneficiado',
          title: 'Nome'
        },
        {
          name: 'beneficio.sigla',
          title: 'Benefício'
        },
        {
          name: '__slot:icon',
          title: 'Período'
        },
        {
          name: 'valor',
          title: 'Valor',
          titleClass: 'text-center',
          dataClass: 'text-right',
          callback(value) {
            return formatarMoeda(Number(value))
          }
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ]
    }
  },
  computed: {
    filtros() {
      const { nome, ano, mes, beneficio } = this
      return {
        nome,
        ano,
        mes,
        beneficio
      }
    },
    pagina: {
      get() {
        const { assistenciaPagamentos } = this.$store.state.vuetableState
        const { pagina } = assistenciaPagamentos
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'assitenciaPagamentos',
          value: value
        })
      }
    },
    nome: {
      get() {
        const { assistenciaPagamentos } = this.$store.state.vuetableState
        const { nome } = assistenciaPagamentos.filtros
        return nome
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'assistenciaPagamentos',
          value: value
        })
        this.resetPageStore()
      }
    },
    ano: {
      get() {
        const { assistenciaPagamentos } = this.$store.state.vuetableState
        const { ano } = assistenciaPagamentos.filtros
        return ano
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'ano',
          collection: 'assistenciaPagamentos',
          value: value
        })
        this.resetPageStore()
      }
    },
    mes: {
      get() {
        const { assistenciaPagamentos } = this.$store.state.vuetableState
        const { mes } = assistenciaPagamentos.filtros
        return mes
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'mes',
          collection: 'assistenciaPagamentos',
          value: value
        })
        this.resetPageStore()
      }
    },
    beneficio: {
      get() {
        const { assistenciaPagamentos } = this.$store.state.vuetableState
        const { beneficio } = assistenciaPagamentos.filtros
        return beneficio
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'beneficio',
          collection: 'assistenciaPagamentos',
          value: value
        })
        this.resetPageStore()
      }
    }
  },
  methods: {
    retornarPeriodo(props) {
      if (props.periodo_inicio && props.periodo_fim) {
        return `de ${new Date(props.periodo_inicio).toLocaleDateString()}
                à ${new Date(props.periodo_fim).toLocaleDateString()}`
      }

      return '_________'
    },
    consultar() {
      this.$nextTick(function() {
        this.$refs.vuetable.refresh()
      })
    },
    limpar() {
      this.nome = ''
      this.mes = ''
      this.ano = ''
      this.beneficio = ''
      this.$refs.vuetable.refresh()
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'assistenciaPagamentos',
        value: 1
      })
    },
    excluir(item) {
      var dt = this.$refs.vuetable

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .post('assistencia/pagamentos/excluir', item)
            .then(response => {
              this.$toastr.s(response.data.msg)
            })
            .catch(error => {
              const { data } = error.response
              this.$toastr.e(
                'Houve um erro ao tentar excluir, atualize a página e tente novamente'
              )
              console.log(data.msg)
            })
            .then(() => {
              dt.refresh()
            })
        }
      }
      this.showConfirm('Deseja realmente deletar este item?', config)
    }
  },
  beforeCreate() {
    request
      .get('/assistencia/listar-beneficios')
      .then(({ data }) => {
        this.beneficios = [...data]
      })
      .catch(error => {
        this.$toastr.e(
          'Houve um erro no carregamento de benefícios. Atualize a página e tente novamente.'
        )
        console.log(error)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/assistencia/pagamentos/index.vue